import type { AddressDraft } from '@repo/domain';

export const formatAddressDraftLine = (draft: AddressDraft | undefined): string | undefined =>
  draft?.line ? `${draft.line}, ${draft.postalCode} ${draft.city}` : undefined;
